'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = CalendarFilled;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function CalendarFilled(_ref) {
  var onClick = _ref.onClick,
      onFocus = _ref.onFocus,
      date = _ref.date,
      dates = _ref.dates,
      otherDates = _ref.otherDates,
      polyglot = _ref.polyglot,
      errors = _ref.errors;

  var times = date.substring(0, 10) in dates ? dates[date.substring(0, 10)] : [];
  return _react2.default.createElement(
    'div',
    {
      id: 'event-dates-box',
      className: 'line-box event-dates-box' + (errors.length > 0 ? ' has-error' : ''),
      onClick: onClick,
      onFocus: onFocus
    },
    _react2.default.createElement(
      'strong',
      null,
      window.Kalendae.moment(date).format('LLLL')
    ),
    _react2.default.createElement('br', null),
    _react2.default.createElement(
      'span',
      { className: 'single-line' },
      times.map(function (item, index) {
        var startDate = window.Kalendae.moment(item.start_date);
        return _react2.default.createElement(
          'span',
          { key: index },
          item.start_date ? startDate.format('HH:mm') : '',
          item.duration ? ' ' + polyglot.t('events.form.calendar.time.to') + ' ' + startDate.add(item.duration, 'seconds').format('HH:mm') : '',
          index !== times.length - 1 ? ', ' : ''
        );
      })
    ),
    _react2.default.createElement('br', null),
    _react2.default.createElement('br', null),
    otherDates
  );
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Form/DatesBox/CalendarFilled.js
// module id = 2207
// module chunks = 0